// Open the tab inside the click and close it on any failure; the portal tab never navigates.
export async function openAuthed(path, browser = {}) {
  const open = browser.open || ((...a) => window.open(...a));
  const fetchDoc = browser.fetch || ((...a) => fetch(...a));
  const token = browser.token || (() => localStorage.getItem('mickey_token'));
  const objectUrl = browser.objectUrl || ((blob) => URL.createObjectURL(blob));
  // An expired session goes to sign-in, as the shared api helper does, instead of showing the refusal's words.
  const signOut = browser.signOut || (() => { localStorage.removeItem('mickey_token'); window.location.href = '/login'; });
  const w = open('', '_blank');
  if (!w) throw new Error('The browser blocked the new tab. Allow pop-ups for this site, then try again.');
  try {
    const res = await fetchDoc(`/api${path}`, { headers: { Authorization: `Bearer ${token()}` } });
    if (res.status === 401) {
      signOut();
      const err = new Error('Unauthorized');
      err.status = 401;
      throw err;
    }
    if (!res.ok) {
      const j = await res.json().catch(() => ({}));
      throw new Error(j.error || `Request failed (${res.status})`);
    }
    w.location.href = objectUrl(await res.blob());
  } catch (e) {
    w.close();
    throw e;
  }
}
